import React from 'react';

interface IYoutubeProps {
    url: string
}

function Youtube({ url }: IYoutubeProps) {
    return (
        <div className="stx-media-wrapper">
            {
                // eslint-disable-next-line jsx-a11y/iframe-has-title
                <iframe src={url} />
            }
        </div>
    );
}

export default Youtube;
